import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { TimeframeOptions } from 'enums/onboarding/crm';
import { SelectOption, FormSelectProps } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const TimeframeSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(TimeframeOptions).map((key) => ({
        id: key,
        label: t(`intake_form.timeframe_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default TimeframeSelect;
